$(document).ready(function () {
  var init = false;
  var swiperInstances = [];

  function createSwiper(containerId, config) {
    var swiper = new Swiper(containerId, config);
    swiperInstances.push(swiper);
  }

  function destroySwipers() {
    swiperInstances.forEach(function (swiper) {
      swiper.destroy();
    });
    swiperInstances = [];
  }

  function swiperCard() {
    if (window.innerWidth <= 767) {
      if (!init) {
        init = true;
        var config1 = {
          slidesPerView: 1,
          spaceBetween: 0,
          grabCursor: true,
          keyboard: true,
          autoHeight: false,
          navigation: {
            nextEl: '#price-card-right-1',
            prevEl: '#price-card-left-1',
          },
        };

        var config2 = {
          slidesPerView: 1,
          spaceBetween: 0,
          grabCursor: true,
          keyboard: true,
          autoHeight: false,
          navigation: {
            nextEl: '#price-card-right-2',
            prevEl: '#price-card-left-2',
          },
        };

        var config3 = {
          slidesPerView: 1,
          spaceBetween: 0,
          grabCursor: true,
          keyboard: true,
          autoHeight: false,
          navigation: {
            nextEl: '#price-card-right-3',
            prevEl: '#price-card-left-3',
          },
        };

        var config4 = {
          slidesPerView: 1,
          spaceBetween: 0,
          grabCursor: true,
          keyboard: true,
          autoHeight: false,
          navigation: {
            nextEl: '#price-card-right-4',
            prevEl: '#price-card-left-4',
          },
        };

        createSwiper('#price-card-slider-1', config1);
        createSwiper('#price-card-slider-2', config2);
        createSwiper('#price-card-slider-3', config3);
        createSwiper('#price-card-slider-4', config4);
        // Add more configurations and createSwiper calls as needed
      }
    } else if (init) {
      destroySwipers();
      init = false;
    }
  }

  swiperCard();
  window.addEventListener('resize', function () {
    swiperCard();
  });
});
